import { isEmpty } from '$utils/objectIsEmpty'

let formDraft

export const draft = {
  get: draftName => {
    if (!formDraft || !formDraft[draftName]) {
      return {}
    }
    return formDraft[draftName]
  },
  getAll: () => {
    if (!formDraft) {
      return {}
    }
    return formDraft
  },
  set: (draftName, draftValues) =>
    (formDraft = {
      ...formDraft,
      ...{ [draftName]: { ...draft.get(draftName), ...draftValues } },
    }),
  unset: (draftName, draftValues?) => {
    if (draftValues && !isEmpty(draft.get(draftName))) {
      delete formDraft[draftName][draftValues]
    }
    if (!draftValues && !isEmpty(draft.get(draftName))) {
      delete formDraft[draftName]
    }
  },
  unsetAll: () => (formDraft = {}),
}



// WEBPACK FOOTER //
// ./src/utils/services/formDraftService.ts